import { render } from "./social-feed.vue?vue&type=template&id=402a2e8e"
import script from "./social-feed.vue?vue&type=script&lang=js"
export * from "./social-feed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__